import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { TrashIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { queryClient } from '@/lib/react-query';

import { getTenantUsersOptions } from '../api/tenant-users';
import { useDeleteUserToken } from '../api/user-token';

interface DeleteTokenButtonProps {
  id: string;
  tenantId: string;
}

export const DeleteTokenButton = ({ id, tenantId }: DeleteTokenButtonProps) => {
  const { t } = useTranslation();

  const { mutate: deleteToken } = useDeleteUserToken({
    mutationConfig: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getTenantUsersOptions(tenantId).queryKey });
        toast.success(t('successfully-deleted-contact'));
      },
    },
  });

  const handleDelete = () => {
    deleteToken({ tenantId, id });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="destructive">
          <TrashIcon aria-hidden />
          <span className="sr-only">{t('delete')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem asChild>
          <Button className="w-full text-white" onClick={handleDelete} variant="destructive">
            <span>{t('delete')}</span>
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
